import { axios } from '@/utils/request'

const baseURL = '/jpaas-jiop-web-server'
function getCookieData (cookieName) {
  try {
    var name = cookieName + '='
    var cookieMsg = document.cookie.replace(/%/g, '%25')
    var decodedCookie = decodeURIComponent(cookieMsg)
    var cookieArray = decodedCookie.split(';')
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return ''
  } catch (err) {
    console.log(err, 'cookieErr')
  }
}
// 使用示例
const token = getCookieData('accessToken')

const api = {
  findItemBySybject: baseURL + '/front/matter/find-item-by-subject', // 查询地方特色分类
  findItemBeanDetail: baseURL + '/front/matter/find-item-bean-detail', // 查询办事指南信息详细版
  findItemBeanSimple: baseURL + '/front/matter/find-item-bean-simple', // 查询办事指南信息简洁版
  findMatterList: baseURL + '/front/matter/find-matter-List', // 查询事项列表interface/handling/findDimensionValue
  findOption: baseURL + '/interface/handling/findDimensionValue', // 查询维度
  findMaterialByIids: baseURL + '/interface/material/findMaterialByIids', // 根据情形查询材料
  fileView: baseURL + '/interface/handling/file-token', // 流程图预览接口
  agentfileView: baseURL + '/interface/agent/file/preview', // 边问边办预览接口
  fileDownload: baseURL + '/front/file/download', // 下载接口
  // 获取补正意见的接口
  getReplayOpinion: baseURL + '/front/matter/toCorrection',
  // 补正提交接口
  submitReplay: baseURL + '/front/matter/correction',
  // 预览接口
  previewFile: baseURL + '/interface/handling/file-token',
  // 查询表单提交加密公钥
  getPublicKey: baseURL + '/interface/handling/getPublicKey',
  // 一件事指南
  oneThingGuide: '/jpaas-jiop-web-server/interface/oneThing/oneThingHandLing',
  // 查询同名一件事
  sameOneThing: '/jpaas-jiop-web-server/interface/oneThing/oneThingName',
  // 查询同名事项
  sanmeMatter: '/jpaas-jiop-web-server/front/matter/itemName',
  // 生成材料接口
  createMaterial: '/jpaas-jiop-web-server/interface/verify/autoConvertWord',
  // 材料列表
  usermaterialList: baseURL + '/interface/usermaterial/list',
  // 材料新增 - 缓存文件上传材料库
  usermaterialAdd: baseURL + '/interface/usermaterial/add',
  // 材料新增
  usermaterialuploadFile: baseURL + '/front/file/uploadFile',
  // 材料删除
  usermaterialDelete: baseURL + '/interface/usermaterial/delete',
  // 材料编辑
  usermaterialModify: baseURL + '/interface/usermaterial/modify',
  // 查询我的材料库管理状态
  materialManagerState: baseURL + '/interface/usermaterial/findMaterialManagerState',
  // 修改管理状态
  changeMaterialManagerState: baseURL + '/interface/usermaterial/modifyMaterialManagerState',
  // 容缺后补 - 上传材料
  modifyMaterialStyle: baseURL + '/interface/handling/modifyMaterialStyle',
  fileDelete: baseURL + '/interface/agent/file/delete',
  modifyAfterIntelligent: baseURL + '/interface/agent/form/modifyAfterIntelligent',
  agentUpload: '/jpaas-jiop-web-server/interface/agent/file/upload',
  findAgentPreviewProgress: '/jpaas-jiop-web-server/interface/agent/handling/findAgentPreviewProgress',
  startPreview: '/jpaas-jiop-web-server/interface/agent/handling/startPreview',
  // 预审查 trigger：上传材料时 fire 一次，让 jdrm 提前 OCR，提交事项时复用终态
  preDocReview: baseURL + '/interface/predocreview/trigger'
}

export const jiopAPI = {
  fileDelete (parameter) {
    return axios({
      url: api.fileDelete,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },

  getPublicKey (parameter) {
    return axios({
      url: api.getPublicKey,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  agentUpload (parameter) {
    return axios({
      url: api.agentUpload,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  modifyAfterIntelligent (parameter) {
    return axios({
      url: api.modifyAfterIntelligent,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'application/json'
      }
    })
  },
  materialManagerState (parameter) {
    return axios({
      url: api.materialManagerState,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  changeMaterialManagerState (parameter) {
    return axios({
      url: api.changeMaterialManagerState,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  usermaterialDelete (parameter) {
    return axios({
      url: api.usermaterialDelete,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  usermaterialModify (parameter) {
    return axios({
      url: api.usermaterialModify,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  usermaterialAdd (parameter) {
    return axios({
      url: api.usermaterialAdd,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  modifyMaterialStyle (parameter) {
    return axios({
      url: api.modifyMaterialStyle,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  usermaterialuploadFile (parameter) {
    return axios({
      url: api.usermaterialuploadFile,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo')).accessToken,
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  usermaterialList (parameter) {
    return axios({
      url: api.usermaterialList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  fileView (parameter) {
    return axios({
      url: api.fileView,
      // headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  agentfileView (parameter) {
    return axios({
      url: api.agentfileView,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  },
  fileDownload (parameter) {
    return axios({
      url: api.fileDownload,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo')).accessToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  },
  findMaterialByIids (parameter) {
    return axios({
      url: api.findMaterialByIids,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findOption (parameter) {
    return axios({
      url: api.findOption,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findMatterList (parameter) {
    return axios({
      url: api.findMatterList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findItemBeanSimple (parameter) {
    return axios({
      url: api.findItemBeanSimple,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findItemBeanDetail (parameter) {
    return axios({
      url: api.findItemBeanDetail,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findItemBySybject (parameter) {
    return axios({
      url: api.findItemBySybject,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getReplayOpinion (parameter) {
    return axios({
      url: api.getReplayOpinion,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  submitReplay (parameter) {
    return axios({
      url: api.submitReplay,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  previewFile (parameter) {
    return axios({
      url: api.previewFile,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  oneThingGuide (parameter) {
    return axios({
      url: api.oneThingGuide,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  sameOneThing (parameter) {
    return axios({
      url: api.sameOneThing,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  sanmeMatter (parameter) {
    return axios({
      url: api.sanmeMatter,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findAgentPreviewProgress (parameter) {
    return axios({
      url: api.findAgentPreviewProgress,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  startPreview (parameter) {
    return axios({
      url: api.startPreview,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  preDocReview (parameter) {
    return axios({
      url: api.preDocReview,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  createMaterial (parameter) {
    return axios({
      url: api.createMaterial,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  }
}
